import AudienceSegmentList from "./AudienceSegmentList";

export default AudienceSegmentList